import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from 'react-router-dom';

const Error = () => {
    const navigating = useNavigate()
    const [sty, setSty] = useState(false);

    const homeClick = () => {
        setSty(true)

        setTimeout(() => {
            navigating('/');
        }, 600)
    }

    useEffect(() => {
        document.title = "Page Not Found";
    }, [])

    return (
        <>
            <span style={{ width: "100%", height: "100vh", position: "fixed", top: 0, left: 0, zIndex: 999, background: "#090a0b", }}></span>
            <video poster="images/spp2.jpg" style={{ position: "fixed", top: 0, left: 0, zIndex: 1000 }} src="images/sp1.mp4" autoPlay={true} muted loop></video>
            <div className="error" style={{
                width: "100%", height: "100vh", position: "fixed", zIndex: "1001", display: "flex", justifyContent: "center", alignItems: "center", transform: sty && "scale(1.5)", opacity: sty && 0, transition: "all 1s linear",
                backgroundPosition: "center center",
                backgroundSize: "cover",
                background: "rgb(9 10 11 / 80%)",
                backdropFilter: "blur(5px)"
            }}>

                <span style={{ width: "80%", position: "relative" }}>
                    <img src="images/er1.png" alt="error" style={{ width: "100%", objectFit: "cover", filter: "drop-shadow(black 3px 3px 5px)" }} />

                    <span
                        style={{
                            fontFamily: "'Poppins', sans-serif",
                            borderRadius: "50px",
                            padding: "10px 20px",
                            color: "white",
                            position: "absolute",
                            left: "9%",
                            cursor: "pointer",
                            top: "41%",
                            background: "red",
                            filter: "drop-shadow(black 3px 3px 5px)"

                        }}
                        onClick={homeClick}>Go to Home</span>
                </span>
            </div>
        </>
    )
}

export default Error;